import logo from "../../assets/Images/logo.svg";
import "./Topbar.css";
function Topbar() {
  return (
    <div className="topbar">
      <div className="header">
        <span></span>
        <img src={logo} />
        <h1 className="title">D'Canvas</h1>
      </div>
    </div>
  );
}

export default Topbar;
